module.exports = __webpack_public_path__ + "img/a.f74808e2.jpg";